import { Component, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { AfiliadosService } from 'src/app/modules/afiliados/afiliados.service';
import { EstadoCuentaFacadeService } from 'src/app/modules/clientes-afiliados/estado-cuenta/estado-cuenta-facade.service';
import { AuthService } from 'src/app/services/auth.service';
import { NotificacionesFacadeService } from 'src/app/services/notificaciones-facade.service';
import { ToastrServiceLocal } from 'src/app/services/toast/toastr.service';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  @ViewChild('menuTriggerNotificaciones') menuTriggerNotificaciones: MatMenuTrigger;
  public dataUsuario: any;
  public notificaciones: any[] = [];
  public nuevasNotificacions: number = 0;y;
 public getfoto: any = '';
   cargandoImagen:boolean

  constructor(public srvAfiliado: AfiliadosService,public estadoCuentaFacade:EstadoCuentaFacadeService,public authServices: AuthService, public router: Router, public notificacionesFacades:NotificacionesFacadeService, public toast:ToastrServiceLocal) { 
    let modulo = JSON.parse(localStorage.getItem("idModulo"));
    
    this.notificacionesFacades.obtenerNotificaciones(modulo, (notificaciones: any[]) => {
      if (notificaciones?.length > 0) {
        this.notificaciones = notificaciones;
        this.revisarNotificaciones();
        if (this.nuevasNotificacions > 0) {
          this.menuTriggerNotificaciones.openMenu();
        }

      }
    });
  }

  ngOnInit() {
    this.cargandoImagen=true;
    this.estadoCuentaFacade.mostrarDatosGenerales('');

    this.estadoCuentaFacade.responseDatosGenerales$.subscribe((result)=>{
      if(result.table0?.length > 0){
        if(result.table0[0].keyImg){
          this.srvAfiliado.mostrasVoucher(result.table0[0].keyImg,data=>{
            this.getfoto=data.data[0].table0[0].url;
            this.cargandoImagen=false;

          });
        }
        
      }
    });
    this.obtenerDataLocal();
    //Toggle Click Function
    $("#menu-toggle").click(function(e) {
      e.preventDefault();
      $("#wrapper").toggleClass("toggled");
      
    });
  }

  obtenerDataLocal() {
    this.dataUsuario = JSON.parse(localStorage.getItem("data_go504"));
    if (!this.dataUsuario) {
      this.router.navigateByUrl('/login');
    }
  }

  revisarNotificaciones() {
    this.nuevasNotificacions = this.notificaciones.filter(n => n?.visto === false)?.length;
  }

  marcarVisto(notificacion) {
    this.notificacionesFacades.marcarVisto({ idNotificacion: notificacion.idNotificacion }, (result) => {

      this.notificaciones = this.notificaciones.filter(n => n.idNotificacion != notificacion.idNotificacion);
      notificacion.visto = true;
      this.notificaciones.push(notificacion);
      this.revisarNotificaciones();
    })
  }

  revisarModalNotificaciones() {
    this.menuTriggerNotificaciones.menuClosed.subscribe(() => {
      let notificaciones = this.notificaciones.filter(n => n.visto === false);
      if (notificaciones?.length > 0) {
        this.menuTriggerNotificaciones.openMenu();

      }
    })
  }

  marcarNotificacionesVista() {
    this.notificacionesFacades.marcarVistoTodos('', (result) => {
      if (result) {
        this.toast.mensajeSuccess("Se marcaron las notificaciones leidas con éxito", "")
        this.revisarNotificaciones();
      }
    })
  }

  cerrarMenu() {
    this.trigger.closeMenu();
  }

}
